<script setup lang="ts">
import Error from '@/components/session/kyc/Error.vue';
import { ref, onErrorCaptured, type ComponentPublicInstance, watch, onMounted } from 'vue';
import * as Sentry from '@sentry/vue';
import { useRoute } from 'vue-router';
import { useKycSessionStore } from '@/stores/kycSession.store';
import { storeToRefs } from 'pinia';
import {
  createKeyboardScrollHandler,
  handleFormFieldEvent,
} from '@/util/keyboardScrollHandlerUtil';
import { getMessage } from '@/components/session/kyc/errorUtil';
import { ImmersveError } from '@/common/ImmersveError';

const inError = ref<boolean>(false);
const route = useRoute();
const { kycSession } = storeToRefs(useKycSessionStore());

onErrorCaptured((e: { err: unknown; instance: ComponentPublicInstance | null; info: string }) => {
  if (e instanceof ImmersveError) {
    Sentry.captureException(e);
  } else {
    const message = getMessage(e); // try to get any message
    Sentry.captureException(
      ImmersveError.create({ name: 'UnhandledKycSessionException', message }),
      {
        extra: { ...e },
      }
    );
  }
  inError.value = true;
  return false;
});

watch(
  () => route.fullPath,
  async () => {
    kycSession.value?.steps.monitorRegionChange(kycSession.value);
  }
);
onMounted(() => {
  const keyboardHandler = createKeyboardScrollHandler();

  document.addEventListener('focusin', (event) => handleFormFieldEvent(event, keyboardHandler));
  document.addEventListener('input', (event) => handleFormFieldEvent(event, keyboardHandler));
  kycSession.value?.steps.monitorRegionChange(kycSession.value);
});
</script>

<template>
  <router-view v-if="!inError"></router-view>
  <Error v-else />
</template>

<style scoped></style>
